import script from "./HrCardSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HrCardSection.vue?vue&type=script&setup=true&lang=js"

import "./HrCardSection.vue?vue&type=style&index=0&id=7266f60b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7266f60b"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection});
